import { createSelector } from '@ngrx/store';
import { State } from '../../store/index';
import { UserState } from '../user.model';

export const userStateSelector = (state: State): UserState => state.user;

export const profileNameSelector = createSelector(userStateSelector, (state) => `${state?.profile?.firstName} ${state?.profile?.lastName}`);

export const profileSelector = createSelector(userStateSelector, (state) => state?.profile);

export const profileIdSelector = createSelector(userStateSelector, (state) => state?.profile?.id);

export const userRecordSelector = createSelector(userStateSelector, (state) => state.userRecord);

export const userRecordIdSelector = createSelector(userStateSelector, (state) => state.userRecord.id);

export const profilePictureSelector = createSelector(userStateSelector, (state) => state?.profile?.picture);

export const userRecordNameSelector = createSelector(userStateSelector, (state) => `${state?.userRecord?.firstName} ${state?.userRecord?.lastName}`);

export const userRecordPictureSelector = createSelector(userStateSelector, (state) => state?.userRecord?.picture);

export const userSearchSelector = createSelector(userStateSelector, (state) => state?.userSearch);

export const userSearchUsersSelector = createSelector(userStateSelector, (state) => state?.userSearch?.users);

export const userSearchPageOptionsSelector = createSelector(userStateSelector, (state) => ({
    pageIndex: state?.userSearch?.pageIndex,
    itemsPerPage: state?.userSearch?.itemsPerPage,
}));

export const userSearchTotalSelector = createSelector(userStateSelector, (state) => state?.userSearch?.total);

export const userSearchQuickFormSelector = createSelector(userStateSelector, (state) => state?.userSearch?.quickSearchForm);

export const userSearchAdvancedFormSelector = createSelector(userStateSelector, (state) => state?.userSearch?.advancedSearchForm);

export const userSearchActiveFormSelector = createSelector(userStateSelector, (state) => state?.userSearch?.activeForm);

export const userScopesSelector = createSelector(userStateSelector, (state) => state?.scopes);

export const userRecordEmailChangedStateSelector = createSelector(userStateSelector, (state) => state?.userRecordEmailChangedState);

export const userSearchQuickFiltersSelector = createSelector(userStateSelector, (state) => state?.userSearch?.quickFilters);
